import { Loader2 } from 'lucide-react';

import { cn } from '../utils/cn';

interface SpinnerProps {
	/** Sizes and colors the spinner: size-* / text-* land on the wrapper, the icon fills it. */
	className?: string;
}

/**
 * The Lucide loader, spun from an HTML wrapper instead of the svg itself.
 * Chromium never runs a CSS animation on the compositor when its target is an
 * `<svg>` root: `<Loader2 className="animate-spin" />` costs a main-thread
 * style + layout + commit pass on every frame (and a full-window repaint until
 * `svg.animate-spin` is promoted in animate.css), which also drags every other
 * running animation onto the main thread. Spinning this span costs nothing.
 */
export const Spinner = ({ className }: SpinnerProps) => (
	<span aria-hidden="true" className={cn('inline-flex shrink-0 animate-spin', className)}>
		<Loader2 className="size-full" />
	</span>
);
